import { downloadQR, downloadAuthorizationQR } from "action/auth";
import { NotificationContext } from "components/CommonComponents/NotificationProvider";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { Button, Popover, PopoverBody } from "reactstrap";
import ViewAuthorizationLetter from "./ViewAuthorizationLetter";

const UserSkillProfile = ({ user, onBack, isLoading, isPDF }) => {
  const { notify } = useContext(NotificationContext);
  const [openPopover, setOpenPopover] = useState(null);
  const [certificatePopover, setCertificatePopover] = useState(null);
  const [authorizationPopover, setAuthorizationPopover] = useState(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const [selected, setSelected] = useState({
    content: null,
    mode: null,
    title: "",
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isMobile = /Android|iPhone|iPad/i.test(navigator.userAgent);

  //   useEffect(() => {
  //   if (isPDF && isMobile) {
  //     const url =
  //       typeof user === "string"
  //         ? user
  //         : URL.createObjectURL(user);

  //     window.open(url, "_blank");

  //     if (user instanceof Blob) {
  //       setTimeout(() => URL.revokeObjectURL(url), 5000);
  //     }
  //   }
  // }, [isPDF, user]);

  const togglePopover = (index) => {
    // setOpenPopover(index);
    setOpenPopover(openPopover === index ? null : index);
  };

  const toggleCertificatePopover = (index) => {
    setCertificatePopover(certificatePopover === index ? null : index);
  };

  const toggleAuthorizationPopover = (index) => {
    setAuthorizationPopover(authorizationPopover === index ? null : index);
  };

  const courseIcons = [
    "fa-bolt",
    "fa-network-wired",
    "fa-shield-alt",
    "fa-award",
    "fa-plug",
    "fa-book-open",
    "fa-cogs",
  ];

  const shuffleIcons = (icons) => {
    return [...icons].sort(() => Math.random() - 0.5);
  };

  const shuffledIcons = useMemo(() => shuffleIcons(courseIcons), []);

  const jointerName =
    [user?.firstName, user?.lastName].filter(Boolean).join(" ") || "N/A";

  const handleDownloadQR = async (ID) => {
    setIsDownloading(true);
    try {
      const res = await downloadQR(ID);
      if (res.status === 200 && res.data) {
        const fileName =
          res.headers["content-disposition"]?.match(/filename="(.+?)"/)?.[1] ||
          "qr-code.png";

        const url = URL.createObjectURL(res.data);

        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(url);
      } else if (res.code === 404) {
        notify(
          "danger",
          "The QR code for this trainee was not found. Please regenerate it.",
        );
      } else {
        notify("danger", "Failed to download QR code. Please try again.");
      }
    } catch (error) {
      notify("danger", "Failed to download QR code. Please try again.");
    }
    setIsDownloading(false);
  };

  const handleDownloadAuthorizationQR = async (ID) => {
    setIsDownloading(true);
    try {
      const res = await downloadAuthorizationQR(ID);
      if (res.status === 200 && res.data) {
        const fileName =
          res.headers["content-disposition"]?.match(/filename="(.+?)"/)?.[1] ||
          "qr-code.png";

        const url = URL.createObjectURL(res.data);

        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(url);
      } else if (res.code === 404) {
        notify(
          "danger",
          "Failed to download authorization letter QR code. Please try again.",
        );
      } else {
        notify(
          "danger",
          "Failed to download authorization letter QR code. Please try again.",
        );
      }
    } catch (error) {
      notify(
        "danger",
        "Failed to download authorization letter QR code. Please try again.",
      );
    }
    setIsDownloading(false);
  };

  const handlePrint = () => {
    window.print();
  };

  const openPDF = () => {
    const url =
      typeof user === "string"
        ? user
        : URL.createObjectURL(user);

    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    a.click();

    if (user instanceof Blob) {
      setTimeout(() => URL.revokeObjectURL(url), 5000);
    }
  };

  return (
    <>
      {isPDF ? (
        isMobile ? (
          <div className="text-center mt-3">
            <button className="btn btn-primary" onClick={openPDF}>
              Open PDF
            </button>
          </div>
        ) : (
          <iframe
            src={
              typeof user === "string"
                ? user
                : URL.createObjectURL(user)
            }
            title="PDF Viewer"
            className="authorizationLetter-iframe"
          />
        )
      ) : (
        <>
          {isDownloading && (
            <div className="logout-overlay">
              <div className="logout-card">
                <i className="fa fa-spinner fa-spin fa-2x text-deep-blue mb-3" />
                <div className="font-weight-bold text-dark">
                  Downloading… Please wait.
                </div>
              </div>
            </div>
          )}
          {isLoading ? (
            <div className="logout-overlay">
              <i className="fa fa-spinner fa-spin fa-3x text-white mb-3" />
            </div>
          ) : (
            <div className="svp-container">
              <div className="svp-header mb-0">
                <Button color="link" className="svp-back" onClick={onBack}>
                  <i className="fas fa-chevron-left mr-2" /> Back
                </Button>
                {/* <Button color="link" className="svp-back" onClick={handleLogout}>
                  <i className="fa-solid fa-arrow-right-from-bracket mr-2" />Logout
                </Button> */}
              </div>
              <p className="svp-title">Jointer Information</p>


              {/* <div className="svp-row"> */}
              {/* <div className="svp-profile-header">
          <div className="svp-profile-left">
            <h2 className="svp-name">Amit Sharma</h2>
            <p className="svp-id">Jointer ID: jointer-id-3</p>

            <div className="svp-profile-stats">
              <div className="svp-badge-stat">
                <i className="fas fa-book" />
                <span>{user?.courseCount || 0} Courses</span>
              </div>
              <div className="svp-badge-stat">
                <i className="fas fa-certificate" />
                <span>{user?.certificateCount || 0} Certificates</span>
              </div>
            </div>

            <div className="svp-profile-qr">
              <img
                src={require("assets/img/brand/rpg-logo.png")}
                alt="QR Code"
              />
              <span>Scan to verify</span>
            </div>
          </div>
        </div> */}
              {/* </div> */}

              <div className="svp-profile">
                <div className="svp-profile-header">
                  <div className="svp-profile-left-section">
                    <div className="svp-avatar-wrapper">
                      <img
                        src={user?.profilePic || require("assets/img/brand/profile.png")}
                        alt="Profile"
                        className="svp-avatar"
                      />
                    </div>

                    <div className="svp-profile-left">
                      <h2 className="svp-name">{jointerName}</h2>
                      <p className="svp-id p-0 m-0">
                        Jointer ID: {user?.jointerID || "NA"}
                      </p>
                      <p className="svp-info p-0 m-0">Designation: {user?.designation || "NA"}</p>
                      {/* <p className="svp-info p-0 m-0">Jointer Type: {user?.jointerType || "NA"}</p> */}
                      {/* <p className="svp-info p-0 m-0">Expert Type: {user?.expertType || "NA"} ({user?.expertLevel || "NA"})</p> */}
                    </div>
                  </div>

                  <div className="svp-profile-right">
                    <div className="svp-badge-stat">
                      <i className="fas fa-book" />
                      <span>{user?.courseCount || 0} Courses</span>
                    </div>
                    <div className="svp-badge-stat">
                      <i className="fas fa-certificate" />
                      <span>{user?.certificateCount || 0} Certificates</span>
                    </div>
                    <div className="svp-badge-stat">
                      <i className="fas fa-file-alt" />
                      <span>{user?.jointerLetters?.length || 0} Letters</span>
                    </div>
                  </div>
                </div>
                <div
                  className="svp-profile-qr cursor"
                  onClick={() => handleDownloadQR(user.jointerEncodedID)}
                >
                  <img src={user.qrCodePath} alt="QR Code" />
                  <span>Scan to verify</span>
                  <small className="qr-download-text">Click to download</small>
                </div>
              </div>

              {(user?.expertTypeImagePath || user?.expertLevel) && (<div className="svp-card mb-4">
                <h3 className="svp-card-header">Jointer's Expertise</h3>
                <div className="svp-experties">
                  <div className="svp-expert">
                    <img src={user?.expertTypeImagePath} alt="Expert Type" />
                    <span>{user?.expertLevel || "NA"}</span>
                  </div>
                </div>
                {/* {user?.skills && user?.skills?.length > 0 ? (
                  <div className="svp-skills scrollable">
                    {user?.skills?.map((skill, i) => (
                      <span key={i} className="svp-skill-pill">
                        {skill}
                      </span>
                    ))}
                  </div>
                ) : (
                  <div className="d-flex justify-content-center align-items-center py-3">
                    <span className="text-muted mt-4">No skills found</span>
                  </div>
                )} */}
              </div>)}

              {user?.jointerLetters && user.jointerLetters.length > 0 && (
                <div className="svp-card mb-4">
                  <div className="svp-authorizations">
                    <h3 className="svp-card-header">Authorization Letters</h3>
                    {user?.jointerLetters && user.jointerLetters.length > 0 ? (
                      <>
                        <div className="svp-auth-grid mb-2">
                          <div className="svp-courses-header">
                            Reference Number
                          </div>
                          <div className="svp-courses-header">Project Name</div>
                          <div className="svp-courses-header">Issue Date</div>
                          <div className="svp-courses-header">Valid Till</div>
                          <div className="svp-courses-header">Status</div>
                          <div className="svp-courses-header ml-4">
                            Authorization Letter
                          </div>
                          <div className="svp-courses-header ml-4">
                            Authorization QR
                          </div>
                        </div>
                        {user.jointerLetters.map((c, index) => {
                          const letterNo = `authorizations-popover-${index}`;

                          return (
                            <div
                              key={index}
                              className={`svp-auth-grid ${authorizationPopover === index
                                ? "svp-auth-hovered"
                                : ""
                                }`}
                            >
                              <div className="svp-auth-cell pointer">
                                <span id={letterNo}>
                                  <span className="svp-auth-no">
                                    {c.certificateNo}
                                  </span>
                                  <i className="fa fa-circle-info fa-sm ml-2" />
                                </span>

                                <Popover
                                  placement="right"
                                  isOpen={authorizationPopover === index}
                                  target={letterNo}
                                  toggle={() => toggleAuthorizationPopover(index)}
                                  trigger="hover"
                                  className="shadow-lg border-0"
                                  popperClassName="svp-authorizations-popover"
                                  container="body"
                                  modifiers={{
                                    preventOverflow: {
                                      enabled: true,
                                      boundariesElement: "viewport",
                                      padding: 8,
                                    },
                                    flip: {
                                      enabled: true,
                                      behavior: ["right"],
                                    },
                                  }}
                                >
                                  <PopoverBody className="svp-auth-popover-body">
                                    <div className="svp-auth-popover-header">
                                      <h6 className="svp-auth-title">
                                        {c.project}
                                      </h6>
                                      <span
                                        className={`svp-auth-status ${c.status === "EXPIRED"
                                          ? "expired"
                                          : "active"
                                          }`}
                                      >
                                        {c.status === "EXPIRED"
                                          ? "Expired"
                                          : "Active"}
                                      </span>
                                      <div className="svp-auth-dates">
                                        <h5 className="label mt-2 mb-0">
                                          Reference Number:
                                          <span className="value">
                                            {c.certificateNo}
                                          </span>
                                        </h5>
                                        {/* {c.groupCertificateNo && ( */}
                                        <h5 className="label mt-0 mb-0">
                                          Issued To Customer:
                                          <span className="value">
                                            {c.issuedToCustomer}
                                          </span>
                                        </h5>
                                        {/* )} */}
                                        <h5 className="label pt-0 mb-0">
                                          Voltage:
                                          <span className="value">
                                            {c.voltage}
                                          </span>
                                        </h5>
                                        {/* {c.groupCertificateNo && ( */}
                                        <h5 className="label pt-0 mb-0">
                                          Agency:
                                          <span className="value">
                                            {c.agency || "-"}
                                          </span>
                                        </h5>
                                        {/* )} */}
                                      </div>
                                    </div>
                                    {/* <hr className="svp-popover-divider" />
                              <div className="svp-cert-desc">
                                <span>
                                  Lorem Ipsum is simply dummy text of the
                                  printing and typesetting industry. Lorem Ipsum
                                  has been the industry's standard dummy text
                                  ever since the 1500s, when an unknown printer
                                  took a galley of type and scrambled
                                </span>
                              </div> */}
                                  </PopoverBody>
                                </Popover>
                              </div>

                              <div className="svp-auth-cell svp-certi-name">
                                {c.project}
                              </div>

                              <div className="svp-auth-cell svp-certificate-date">
                                {c.issueDate}
                              </div>
                              <div className="svp-auth-cell svp-certificate-date">
                                {c.validTill}
                              </div>
                              <div className="svp-auth-cell">
                                <span
                                  className={`svp-badge ${c.status === "EXPIRED" ? "expired" : "active"
                                    }`}
                                >
                                  {c.status === "EXPIRED" ? "EXPIRED" : "ACTIVE"}
                                </span>
                              </div>
                              {/* && user?.isExternalVisitor */}
                              {(c?.certificateNoPath || (c?.status === "EXPIRED")) ? (
                                <div className="svp-auth-cell svp-auth-view text-center">
                                  <span
                                    className="pointer"
                                    onClick={() => {
                                      setSelected({
                                        content: c.certificateNoPath,
                                        mode: "pdf",
                                        title: "Authorization Letter",
                                        showToolbar: !user?.isExternalVisitor && c?.status !== "EXPIRED",
                                        status: c?.status,
                                        isExternalVisitor: user?.isExternalVisitor
                                      });
                                      setIsModalOpen(true);
                                    }}
                                  >
                                    <i className="fa fa-eye fa-sm mr-1" /> View
                                  </span>
                                </div>
                              ) : (
                                <span className="text-center">NA</span>
                              )}
                              {c.status !== "EXPIRED" && c?.certificateNoQrPath ? (
                                <div className={`svp-auth-cell text-center ${user?.isExternalVisitor ? "svp-ex-view" : "svp-qr-view"}`}>
                                  <span
                                    className="pointer"
                                    onClick={() => {
                                      setSelected({
                                        content: c.certificateNoQrPath,
                                        mode: "qr",
                                        title: "Authorization Letter QR Code",
                                      });
                                      setIsModalOpen(true);
                                    }}
                                  >
                                    <i className="fa fa-eye fa-sm mr-1" /> View
                                  </span>
                                  {!user?.isExternalVisitor && <span
                                    className="pointer"
                                    onClick={() =>
                                      handleDownloadAuthorizationQR(
                                        c.certificateEncodedNo,
                                      )
                                    }
                                  >
                                    <i className="fa fa-download fa-sm mr-1" />{" "}
                                    download
                                  </span>}
                                </div>
                              ) : (
                                <span className="text-center">NA</span>
                              )}
                            </div>
                          );
                        })}
                      </>
                    ) : (
                      <div className="text-center text-muted pt-5 text-md">
                        No authorization letters found
                      </div>
                    )}
                  </div>
                </div>)}

              {user?.jointerCourseCertificates && user.jointerCourseCertificates.length > 0 && (
                <div className="svp-card mb-4">
                  <div className="svp-certifications">
                    <h3 className="svp-card-header">Certifications & Validity</h3>
                    {user?.jointerCourseCertificates && user.jointerCourseCertificates.length > 0 ? (
                      <>
                        <div className="svp-cert-grid mb-2">
                          <div className="svp-courses-header">
                            Certification Name
                          </div>
                          <div className="svp-courses-header">Status</div>
                          <div className="svp-courses-header">Valid From</div>
                          <div className="svp-courses-header">Valid To</div>
                        </div>
                        {user.jointerCourseCertificates.map((c, index) => {
                          const certificateNo = `certificate-popover-${index}`;

                          return (
                            <div
                              key={index}
                              className={`svp-cert-grid ${certificatePopover === index
                                ? "svp-certi-hovered"
                                : ""
                                }`}
                            >
                              <div className="svp-cert-cell pointer">
                                <span id={certificateNo}>
                                  <span className="svp-certi-name">
                                    {c.certificateName}
                                  </span>
                                  <i className="fa fa-circle-info fa-sm ml-2" />
                                </span>

                                <Popover
                                  placement="right"
                                  isOpen={certificatePopover === index}
                                  target={certificateNo}
                                  toggle={() => toggleCertificatePopover(index)}
                                  trigger="hover"
                                  className="shadow-lg border-0"
                                  popperClassName="svp-certificate-popover"
                                  container="body"
                                  modifiers={{
                                    preventOverflow: {
                                      enabled: true,
                                      boundariesElement: "viewport",
                                      padding: 8,
                                    },
                                    flip: {
                                      enabled: true,
                                      behavior: ["right"],
                                    },
                                  }}
                                >
                                  <PopoverBody className="svp-cert-popover-body">
                                    <div className="svp-cert-popover-header">
                                      <h6 className="svp-cert-title">
                                        {c.certificateName}
                                      </h6>
                                      <span
                                        className={`svp-cert-status ${c.status === "INACTIVE"
                                          ? "expired"
                                          : "active"
                                          }`}
                                      >
                                        {c.status === "INACTIVE"
                                          ? "Expired"
                                          : "Active"}
                                      </span>
                                      <div className="svp-cert-dates">
                                        <h5 className="label mt-2 mb-0">
                                          Certificate No:
                                          <span className="value">
                                            {c.certificateNo}
                                          </span>
                                        </h5>
                                        {c?.groupCertificateNo && (
                                          <h5 className="label pt-0 mt-0">
                                            Group Certificate No:
                                            <span className="value">
                                              {c?.groupCertificateNo}
                                            </span>
                                          </h5>
                                        )}
                                      </div>
                                    </div>
                                    <hr className="svp-popover-divider" />
                                    <div className="svp-cert-desc">
                                      <span>
                                        Lorem Ipsum is simply dummy text of the
                                        printing and typesetting industry. Lorem
                                        Ipsum has been the industry's standard
                                        dummy text ever since the 1500s, when an
                                        unknown printer took a galley of type and
                                        scrambled
                                      </span>
                                    </div>
                                  </PopoverBody>
                                </Popover>
                              </div>

                              <div className="svp-cert-cell">
                                <span
                                  className={`svp-badge ${c.status === "INACTIVE" ? "expired" : "active"
                                    }`}
                                >
                                  {c.status === "INACTIVE" ? "EXPIRED" : "ACTIVE"}
                                </span>
                              </div>

                              <div className="svp-cert-cell svp-certificate-date">
                                {c.startDate}
                              </div>
                              <div className="svp-cert-cell svp-certificate-date">
                                {c.endDate}
                              </div>
                            </div>
                          );
                        })}
                      </>
                    ) : (
                      <div className="text-center text-muted pt-5 text-md">
                        No certifications found
                      </div>
                    )}
                  </div>
                </div>)}

              {user?.courses && user?.courses?.length > 0 && (
                <div className="svp-card">
                  <h3 className="svp-card-header">Undertaken Courses</h3>
                  <div className="svp-courses-list">
                    {/* {user?.courses && user.courses.length > 0 ? ( */}
                    {user?.courses && user?.courses?.length > 0 ? (
                      <>
                        <div className="svp-courses-grid mb-2">
                          <div className="svp-courses-header">Course Name</div>
                          <div className="svp-courses-header">Level</div>
                          <div className="svp-courses-header">Status</div>
                          <div className="svp-courses-header">Completed On</div>
                        </div>

                        {user?.courses?.map((c, index) => {
                          const icon =
                            shuffledIcons[index % shuffledIcons.length];
                          const popoverId = `course-popover-${index}`;
                          const levelName =
                            c?.courseLevel?.charAt(0)?.toUpperCase() +
                            c?.courseLevel?.slice(1)?.toLowerCase();

                          return (
                            <div
                              key={index}
                              className={`svp-courses-grid ${openPopover === index ? "svp-course-hovered" : ""
                                }`}
                            >
                              <div className="svp-grid-cell">
                                <div className="svp-name-item">
                                  <div className="svp-course-icon">
                                    <i className={`fas ${icon}`} />
                                  </div>
                                  <span id={popoverId} className="pointer">
                                    <span className="svp-course-name">
                                      {c.courseName}
                                    </span>
                                    <i className="fa fa-circle-info fa-sm ml-2" />
                                  </span>
                                </div>

                                {Array.isArray(c.description) &&
                                  c.description.length > 0 && (
                                    <Popover
                                      placement="right"
                                      isOpen={openPopover === index}
                                      target={popoverId}
                                      toggle={() => togglePopover(index)}
                                      trigger="hover"
                                      className="shadow-lg border-0"
                                      popperClassName="svp-course-popover"
                                      container="body"
                                    >
                                      <PopoverBody>
                                        <h6 className="svp-popover-title mb-2">
                                          {c.courseName}
                                        </h6>
                                        <hr className="svp-popover-divider" />
                                        <ul className="svp-popover-list">
                                          {c.description.map((d, i) => (
                                            <li key={i}>{d}</li>
                                          ))}
                                        </ul>
                                      </PopoverBody>
                                    </Popover>
                                  )}
                              </div>

                              <div className="svp-grid-cell">
                                <span className="svp-course-level">
                                  {levelName || "-"}
                                </span>
                              </div>

                              <div className="svp-grid-cell">
                                <span
                                  className={`svp-badge 
                          ${c.courseStatus === "IN-PROGRESS"
                                      ? "inprogress"
                                      : "active"
                                    }`}
                                >
                                  {c.courseStatus}
                                </span>
                              </div>

                              <div className="svp-grid-cell svp-course-date ">
                                {c.completionDate || "-"}
                              </div>
                            </div>
                          );
                        })}
                      </>
                    ) : (
                      <div className="d-flex justify-content-center align-items-center py-3">
                        <span className="text-muted mt-4">No courses found</span>
                      </div>
                    )}
                  </div>
                </div>)}

              <div>
                <div className="svp-thankyou">
                  <p className="svp-thankyou-title">
                    Thank you for visiting the Raychem RPG Jointer Verification
                    Portal.
                  </p>
                  {/* <p className="svp-thankyou-subtitle">
                    For more details, certifications, or verification support,
                    visit{" "}
                    <a
                      href="https://www.raychemrpg.com"
                      target="_blank"
                      rel="noreferrer"
                    >
                      www.raychemrpg.com
                    </a>
                  </p> */}
                </div>

                {/* <div className="print-btn">
                  <Button
                    color="vivid-red"
                    className="no-print"
                    onClick={handlePrint}
                  >
                    <i className="fas fa-print mr-2" />
                    Print
                  </Button>
                </div> */}
              </div>
            </div>
          )}
          <ViewAuthorizationLetter
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            content={selected.content}
            mode={selected.mode}
            title={selected.title}
            showToolbar={selected.showToolbar}
            certificateStatus={selected?.status}
            isExternalVisitor={selected?.isExternalVisitor}
          />
        </>
      )}
    </>
  );
};

export default UserSkillProfile;

{
  /* <div className="svp-card mb-4">
        <div className="svp-certifications">
          <h3 className="svp-card-header">Certifications & Validity</h3>
          <div className="svp-table-wrapper">
            <table className="svp-table">
              <thead>
                <tr>
                  <th>Certification Name</th>
                  <th>Status</th>
                  <th>Valid From</th>
                  <th>Valid To</th>
                </tr>
              </thead>
              <tbody>
                {user?.certificates && user?.certificates?.length > 0 ? (
                  user?.certificates?.map((c, index) => {
                    const certificateNo = `authorizations-popover-${index}`;

                    return (
                      <tr
                        key={index}
                        className={`svp-certi ${
                          certificatePopover === index
                            ? "svp-auth-hovered"
                            : ""
                        }`}
                      >
                        <td className="wrap-text pointer">
                          <span id={certificateNo}>
                            <span className="svp-certi-name ml-2">
                              {c.certificateName}
                            </span>{" "}
                            <i className="fa fa-circle-info fa-sm ml-2" />
                          </span>
                        </td>
                        <td>
                          <span
                            className={`svp-badge ${
                              c.status === "INACTIVE" ? "expired" : "active"
                            }`}
                          >
                            {c.status === "INACTIVE" ? "EXPIRED" : c.status}
                          </span>
                        </td>
                        <td className="svp-certificate-date">{c.startDate}</td>
                        <td className="svp-certificate-date">{c.endDate}</td>
                        <Popover
                          placement="right"
                          isOpen={certificatePopover === index}
                          target={certificateNo}
                          toggle={() => toggleCertificatePopover(index)}
                          trigger="hover"
                          className="shadow-lg border-0"
                          popperClassName="svp-authorizations-popover"
                          container="body"
                          modifiers={{
                            preventOverflow: {
                              enabled: true,
                              boundariesElement: "viewport",
                              padding: 8,
                            },
                            flip: {
                              enabled: true,
                              behavior: ["right"],
                            },
                          }}
                        >
                          <PopoverBody className="svp-auth-popover-body">
                            <div className="svp-auth-popover-header">
                              <h6 className="svp-auth-title">
                                {c.certificateName}
                              </h6>
                              <span
                                className={`svp-auth-status ${
                                  c.status === "INACTIVE" ? "expired" : "active"
                                }`}
                              >
                                {c.status === "INACTIVE" ? "Expired" : "Active"}
                              </span>
                            </div>
                            <hr className="svp-popover-divider" />
                            <div className="svp-cert-desc">
                              <span>
                                Lorem Ipsum is simply dummy text of the printing
                                and typesetting industry. Lorem Ipsum has been
                                the industry's standard dummy text ever since
                                the 1500s, when an unknown printer took a galley
                                of type and scrambled
                              </span>
                            </div>
                          </PopoverBody>
                        </Popover>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      colSpan="4"
                      className="text-center text-muted pt-5 text-md"
                    >
                      No certifications found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div> */
}

{
  /* <div className="svp-courses-list scrollable pr-3">
          {user?.courses && user?.courses?.length > 0 ? (
            user?.courses?.map((c, index) => {
              const icon = shuffledIcons[index % shuffledIcons.length];
              const popoverId = `course-popover-${index}`;
              // const tooltipId = `course-tooltip-${index}`;

              return (
                <div
                  key={index}
                  className={`svp-course ${
                    openPopover === index ? "svp-course-hovered" : ""
                  }`}
                >
                  <div className="svp-course-icon">
                    <i className={`fas ${icon}`} />
                  </div>

                  <div className="svp-course-info">
                    <span className="svp-course-text">
                      <span id={popoverId}>
                        <span className="svp-course-name">{c.courseName}</span>
                        <i className="fa fa-circle-info fa-sm ml-2" />
                      </span>
                      <span className="levels">
                        <span className="svp-course-level">Level 1</span>
                      </span>
                      <span className="svp-course-date">
                        Completed on {c.completionDate}
                      </span>
                    </span>

                    {Array.isArray(c.description) &&
                      c.description.length > 0 && (
                        <Popover
                          placement="right"
                          isOpen={openPopover === index}
                          target={popoverId}
                          toggle={() => togglePopover(index)}
                          trigger="hover"
                          className="shadow-lg border-0"
                          popperClassName="svp-course-popover"
                          container="body"
                          modifiers={{
                            preventOverflow: {
                              enabled: true,
                              boundariesElement: "viewport",
                              padding: 8,
                            },
                            flip: {
                              enabled: true,
                              behavior: ["right"],
                            },
                          }}
                        >
                          <PopoverBody>
                            <div className="d-flex align-items-center justify-content-between">
                              <h6 className="svp-popover-title m-0">
                                {c.courseName}
                              </h6>

                              <span className="d-flex align-items-center">
                                <i className="fas fa-calendar-alt mr-2  text-deep-blue" />
                                <span className="font-weight-bold">
                                  {c.completionDate}
                                </span>
                              </span>
                            </div>

                            <hr className="svp-popover-divider" />

                            <p className="svp-popover-subtitle">Description:</p>
                            <ul className="svp-popover-list">
                              {c.description.map((d, i) => (
                                <li key={i}>{d}</li>
                              ))}
                            </ul>
                          </PopoverBody>
                        </Popover>
                      )}
                  </div>
                </div>
              );
            })
          ) : (
            <div className="d-flex justify-content-center align-items-center py-3">
              <span className="text-muted mt-4">No courses found</span>
            </div>
          )}
        </div> */
}
